import React from 'react'
import TableComponent, { TableOp } from '../../components/table/TableOps';

export default class GuiaLog extends TableComponent {

  componentDidMount() {
    let pgId = this.props.id;
    this.tableConfig(
      { dataUrl: `ead/logs/${pgId}`, deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Historial de cambios', [
        { label: 'Folio', id: 'id' },
        { label: 'Fecha Cita', id: 'fecha_ead' },
        { label: 'Concepto', id: 'descripcion' },
        { label: 'Fecha de Modificacion', id: 'edited_date' },
        { label: 'Usuario', id: 'user' },
      ], []))
    this.table();
  }

  render() {
    return (
      <div>
          <this.TableRender pagination={false} />
      </div>
    )
  }
}
